import { useEffect, useState } from "react";
import useKeycloakContext from "./useKeycloakContext";

const useUser = () => {
  const [user, setUser] = useState(null);
  const context = useKeycloakContext();

  useEffect(() => {
    if (context?.keycloak.authenticated) {
      const role = context.keycloak.tokenParsed?.groups[0]?.slice(1);
      setUser({ ...context.getUserData(), role });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.keycloak.authenticated]);
  return user;
};

export default useUser;
